/**
 * Legacy WalkinsApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.walkinsApi`) keep resolving.
 *
 * The actual WalkinsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/walkins/walkins-api.service.ts
 */
angular.module("acme.common.service.walkinsApi", []);
